import { render, staticRenderFns } from "./EmployerHome.vue?vue&type=template&id=531aea3f&scoped=true&"
import script from "./EmployerHome.vue?vue&type=script&lang=ts&"
export * from "./EmployerHome.vue?vue&type=script&lang=ts&"
import style0 from "./EmployerHome.vue?vue&type=style&index=0&id=531aea3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531aea3f",
  null
  
)

component.options.__file = "EmployerHome.vue"
export default component.exports